import { __decorate, __metadata } from "tslib";
import { SerializableObject, SerializableMember } from '../decorators';
import { MagnetismUnit } from '../../utils';
import { SensorValue } from './SensorValue';
/**
 * @category Sensor Value
 */
let Magnetism = class Magnetism extends SensorValue {
  constructor(x, y, z, unit = MagnetismUnit.MICROTESLA) {
    super(x, y, z, unit, MagnetismUnit.MICROTESLA);
  }
};
__decorate([SerializableMember(), __metadata("design:type", MagnetismUnit)], Magnetism.prototype, "unit", void 0);
Magnetism = __decorate([SerializableObject(), __metadata("design:paramtypes", [Number, Number, Number, Object])], Magnetism);
export { Magnetism };